<template>
    <div>
        <Header />
        <div class="container">
            <div class="row">
                <div class="col-sm-12 text-left">
                    <a v-on:click.prevent="backToHome()">
                        <img class="volver" src="@/assets/img/volver.png">
                        Volver a búsqueda
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Header from '@/components/HeaderComponent.vue'
    export default {
        components: {
            Header
        },
        methods: {
            backToHome() {
                this.$router.push({
                    name: 'Home'
                });
            }
        }
    }
</script>

<style>

</style>